import { type FC } from 'react';

interface PeriodFilterProps {
  value: number | null;
  onChange: (limit: number | null) => void;
  totalDraws: number;
}

const PERIOD_OPTIONS: { label: string; value: number | null }[] = [
  { label: '전체', value: null },
  { label: '50회', value: 50 },
  { label: '100회', value: 100 },
  { label: '200회', value: 200 },
  { label: '500회', value: 500 },
];

const PeriodFilter: FC<PeriodFilterProps> = ({ value, onChange, totalDraws }) => {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-xs text-foreground-400 flex-shrink-0">
        <i className="ri-filter-3-line mr-1"></i>
        분석 기간
      </span>
      <div className="flex items-center gap-1 bg-background-100 rounded-full p-1">
        {PERIOD_OPTIONS.map((opt) => {
          const isActive = value === opt.value;
          const disabled = opt.value !== null && opt.value > totalDraws;
          return (
            <button
              key={opt.label}
              onClick={() => !disabled && onChange(opt.value)}
              disabled={disabled}
              className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all duration-200 whitespace-nowrap ${
                isActive
                  ? 'bg-background-50 text-foreground-900 shadow-sm cursor-pointer'
                  : disabled
                    ? 'text-foreground-200 cursor-not-allowed'
                    : 'text-foreground-400 hover:text-foreground-600 cursor-pointer'
              }`}
            >
              {opt.label}
            </button>
          );
        })}
      </div>
      {value && (
        <span className="text-[11px] text-foreground-300">
          최근 {Math.min(value, totalDraws).toLocaleString()}회차 기준
        </span>
      )}
    </div>
  );
};

export default PeriodFilter;